import { Button, palette, space } from "@minervaproject/fds";
import { ChangeEvent, KeyboardEvent, useEffect, useRef, useState } from "react";

import { useAppDispatch, useAppSelector } from "hooks/redux_hooks";
import { ClassEventTypeType } from "shared/types/class_event";
import { classroomSelectors, localSelectors } from "store";
import { createClassEvent } from "store/reducers/monitoring";

function BookmarkForm({ hideModal }: { hideModal: () => void }) {
  const dispatch = useAppDispatch();
  const inputRef = useRef<HTMLInputElement>(null);
  const [note, setNote] = useState("");
  const currentUserId = useAppSelector(localSelectors.selectCurrentUserId());
  const activeRoomId = useAppSelector(classroomSelectors.selectActiveRoomIdForCurrentUser());
  const startTime = useRef(Date.now());

  const isNoteValid = () => {
    return note.trim().length > 0;
  };
  const handleSubmit = () => {
    dispatch(
      createClassEvent({
        type: ClassEventTypeType.BOOKMARK_NOTE,
        userId: currentUserId,
        roomId: activeRoomId,
        data: { note_text: note.trim(), additional_offset: Date.now() - startTime.current },
      }),
    );
    hideModal();
  };

  const onKeyDown = (event: KeyboardEvent) => {
    if (event.key === "Enter" && event.metaKey && isNoteValid()) {
      handleSubmit();
    }
    if (event.key === "Escape") {
      hideModal();
    }
  };

  useEffect(() => {
    // Here, we use a hook to focus on the input field instead of using autofocus
    // because autofocus would cause a key to be typed into the input field
    // if the user used the keyboard shortcut to open the modal.
    inputRef.current?.focus();
  }, []);

  return (
    <form
      onSubmit={(e) => {
        e.preventDefault();
      }}
    >
      <div
        style={{
          background: "transparent",
          border: "none",
          flexGrow: 1,
          minWidth: 0,
          outline: "none",
        }}
      >
        <input
          ref={inputRef}
          className="body-s"
          aria-label="bookmark-note"
          placeholder="Type bookmark note here"
          onChange={(event: ChangeEvent<HTMLInputElement>) => setNote(event.target.value)}
          type="text"
          onKeyDown={onKeyDown}
          style={{
            alignItems: "stretch",
            background: palette.white,
            border: `1px solid ${palette.blackTint90}`,
            borderRadius: 2,
            display: "inline-flex",
            height: space[8],
            padding: `0 ${space[3]}px`,
            width: "374px",
          }}
        />
      </div>
      <Button type="submit" disabled={!isNoteValid()} mt={5} onClick={handleSubmit}>
        Submit
      </Button>
    </form>
  );
}

export { BookmarkForm };
